module.exports = __webpack_public_path__ + "img/CV_Holecz_Peter_Eng.b5346aad.jpg";